import { createFileRoute } from "@tanstack/react-router";
import { routeMeta } from "@/lib/route-meta";
import DeveloperLanding from "@/pages/DeveloperLanding";

export const Route = createFileRoute("/developer/$developer")({ head: ({ params }) => routeMeta('Developer Properties | MNRE', 'Explore Mumbai properties from this developer with MNRE.', `/developer/${params.developer}`), component: DeveloperLanding });
